import { Divider, Grid } from "@mui/material";
import React, { createContext } from "react";
import EmployeeAddress from "./EmployeeAddress/EmployeeAddress";
import EmployeeBankAccount from "./EmployeeBankAccount/EmployeeBankAccount";
import EmployeeDependents from "./EmployeeDependents/EmployeeDependents";
import { EmployeeDataProps } from "./interfaces";

import { EmployeeDTO } from "../../models/employees";

export const EmployeeDataContext = createContext<EmployeeDataProps>({
  employee: null,
  forManager: false,
});
const EmployeePersonalData = ({ employee, forManager }: { employee: EmployeeDTO | null; forManager: boolean }) => {
  return (
    <EmployeeDataContext.Provider value={{ employee, forManager }}>
      <Grid
        style={{
          display: "flex",
          flexDirection: "column",
          gap: "15px",
          minWidth: "40%",
        }}
      >
        <EmployeeAddress />

        <Divider
          orientation="horizontal"
          style={{ width: "90%", alignSelf: "center" }}
        />
        <EmployeeBankAccount />
        <Divider
          orientation="horizontal"
          style={{ width: "90%", alignSelf: "center" }}
        />

        <EmployeeDependents />
      </Grid>
    </EmployeeDataContext.Provider>
  );
};
export default EmployeePersonalData;
